import ApiService from "@/common/api.service"

export const RegistrationReportService = {
    getRegistrationReports() {
        return ApiService.get("/eventReport")
    },
    getRegistrationReportstWP(query) {
        return ApiService.get(`/eventReport${query}`);
    },

}